// The demo organisation (DEMO, Master Prompt A37 (b), D3). The organisation whose code is KES-DEMO
// is the demonstration, and the code is its only flag: the backend seed
// (backend/app/demo/fixtures.py) works in this organisation only, and the shell shows a DEMO
// badge while a session of it is signed in.
export const DEMO_ORGANIZATION_CODE = "KES-DEMO";

// Its accounts may not change their own password (follow-up 43): the shared login would otherwise
// be one visitor's to lock. The server refuses the change with the same words.
export const DEMO_PASSWORD_NOTE =
  "The accounts of the demo organisation cannot change their own password; " +
  "the demo's owner sets it.";

export function isDemoOrganization(code: string): boolean {
  return code === DEMO_ORGANIZATION_CODE;
}
